export default [
  {
    path: "/reports/submissions",
    name: "report-submissions",
    meta: {
      title: "Reports and Submissions",
      authRequired: true,
    },
    component: () => import("../views/report-submissions/index.vue"),
  },
  {
    path: "/reports/submissions/:submissionId",
    name: "report-submission-workspace",
    meta: {
      title: "Report Submission",
      authRequired: true,
    },
    component: () => import("../views/report-submissions/workspace.vue"),
  },
  {
    path: "/reports/submissions/:submissionId/review",
    name: "report-submission-review",
    meta: {
      title: "Review Report Changes",
      authRequired: true,
    },
    component: () => import("../views/report-submissions/review.vue"),
  },
  {
    path: "/reports/submissions/:submissionId/certification",
    name: "report-submission-certification",
    meta: {
      title: "Certify and Submit Report",
      authRequired: true,
    },
    component: () => import("../views/report-submissions/certification.vue"),
  },
];
